import TemplateView from '../../../../../../js/TemplateView'
import {FEEDS_TOOLTIP_EXTRA_CLASS} from '../../../constants'
import tooltip from '../../../../../../js/SimpleSingletonTooltip'

export default class LeaveTypeIcon extends TemplateView {
    constructor({
        name,
        iconId,
    }) {
        super()

        this.params = {
            name,
            iconId,
        }
    }

    templateHtml() {
        return `<div class='leaveTypeIcon'>
                    <img src='<%=iconPath%>'/>
                </div>`
    }

    templateModel() {
        return {
            iconPath: window.getLeaveTypeIconPath(this.params.iconId)
        }
    }

    afterRender() {
        tooltip(this.getEl(), {
            text: this.params.name,
            extraClass: FEEDS_TOOLTIP_EXTRA_CLASS
        })
    }
}



// WEBPACK FOOTER //
// ./web/actiplans/js/icalendar/components/table/cells/LeaveTypeIcon.js